import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import bannerImg from "../../assets/img/banner2.jpg";
import AOS from "aos";

const DigitalTransformationSection = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section
      className="digital-transformation-section position-relative pt-120 pb-100 md-pt-90 md-pb-70"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-lg-6 mb-40 md-mb-0"
            data-aos="fade-up"
            data-aos-duration="1200"
          >
            <span
              style={{
                display: "inline-block",
                background: "#ffc107",
                color: "#222",
                fontWeight: 700,
                borderRadius: 24,
                padding: "6px 20px",
                fontSize: 15,
                letterSpacing: 1,
                boxShadow: "0 2px 8px rgba(255,193,7,0.08)",
                marginBottom: 12,
              }}
            >
              <i className="fa fa-lightbulb-o" style={{ marginRight: 8 }}></i>
              Digital Transformation Consulting
            </span>
            <h2 style={{ fontWeight: 800, fontSize: 36, marginBottom: 18, color: "#222" }}>
              Accelerate Your <span style={{ color: "#ffc107" }}>Digital Transformation</span>
            </h2>
            <p style={{ fontSize: 18, color: "#444", marginBottom: 32, maxWidth: 500 }}>
              Reimagine your future with digital-first strategies. We modernize your processes and technology to drive innovation, efficiency, and sustainable growth.
            </p>
            <div style={{ display: "flex", gap: 18, flexWrap: "wrap" }}>
              <Link
                className="readon2"
                to="/consultation"
                style={{ display: "inline-flex", alignItems: "center", fontWeight: 600, fontSize: 17 }}
              >
                <i className="fa fa-rocket" style={{ marginRight: 8 }}></i>
                Start Your Transformation
              </Link>
            </div>
          </div>
          <div
            className="col-lg-6 d-none d-md-flex justify-content-center position-relative"
            data-aos="fade-left"
            data-aos-duration="1200"
          >
            <div style={{ position: "relative", width: "100%", maxWidth: 600, background: "transparent" }}>
              <img
                src={bannerImg}
                alt="Digital Transformation"
                style={{
                  width: "90%",
                  borderRadius: 12,
                  border: "none",
                  objectFit: "cover",
                  minHeight: 400,
                  maxHeight: 500,
                  filter: "brightness(0.98)",
                  background: "transparent"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DigitalTransformationSection; 